// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AiDocumentToggle: 'ai-document-toggle',
	AiDocumentToggle1: 'ai-document-toggle-1',
	UploadFilesButton: 'upload-files-button',
	ContinueButton: 'continue-button',
	AddCommissionStatementCheckbox: 'add-commission-statement-checkbox',
	AddBuyerBrokerageCommissionStatementCheckbox:
		'add-buyer-brokerage-commission-statement-checkbox',
	Dropzone: 'dropzone',
	Dropzone1: 'dropzone-1',
	Dropzone2: 'dropzone-2',
	Dropzone3: 'dropzone-3',
	InternetFile: 'internet-file',
	InternetFile1: 'internet-file-1',
	InternetFile2: 'internet-file-2',
	MessageBar: 'message-bar',
	IntroducingAiNote: 'introducing-ai-note',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
